module.exports = __webpack_public_path__ + "static/img/p3_img2.5e27908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3_img2.png
// module id = DqY3
// module chunks = 0